import { useCallback } from 'react';
import {
  trackEvent,
  trackPhoneClick,
  trackEmailClick,
  trackEmergencyClick,
  trackServiceInquiry,
  trackPortfolioView,
  trackOutboundLink,
} from '@/components/analytics/GoogleAnalytics';

export const useAnalytics = () => {
  const handlePhoneClick = useCallback((phoneNumber: string) => {
    trackPhoneClick(phoneNumber);
  }, []);

  const handleEmailClick = useCallback((email: string) => {
    trackEmailClick(email);
  }, []);

  const handleEmergencyClick = useCallback(() => {
    trackEmergencyClick();
  }, []);

  const handleServiceInquiry = useCallback((serviceName: string) => {
    trackServiceInquiry(serviceName);
  }, []);

  const handlePortfolioView = useCallback((projectName: string) => {
    trackPortfolioView(projectName);
  }, []);

  const handleOutboundLink = useCallback((url: string) => {
    trackOutboundLink(url);
  }, []);

  const trackCustomEvent = useCallback(
    (eventName: string, params?: Record<string, unknown>) => {
      trackEvent(eventName, params);
    },
    []
  );

  return {
    trackPhoneClick: handlePhoneClick,
    trackEmailClick: handleEmailClick,
    trackEmergencyClick: handleEmergencyClick,
    trackServiceInquiry: handleServiceInquiry,
    trackPortfolioView: handlePortfolioView,
    trackOutboundLink: handleOutboundLink,
    trackCustomEvent,
  };
};

export default useAnalytics;
